import {getCategoryApi} from "../../api/entities/categories";
import {createCrudSlice} from "../genericCrudSlice";


const categoriesCrudSlice = createCrudSlice('categories', 'Edit Category', 'New Category', getCategoryApi);
export const {openModalForEdit} = categoriesCrudSlice;
export const {reset, openModalForCreate, closeModal, setItem} = categoriesCrudSlice.actions;
export default categoriesCrudSlice.reducer;